import { useDispatch, useSelector } from 'react-redux';
import { store } from './index';

// Custom hooks for using Redux store
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;

// Helper function to get store state
export const getStoreState = () => store.getState();

// Helper function to get store dispatch
export const getStoreDispatch = () => store.dispatch;
